import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router }            from '@angular/router';
import { AppModule }              from '../app.module';


import * as ent from '../entities/index'
import * as enums from '../enums/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'
import * as util from '../util/index'

//components
import {AttachmentsComponent} from '../components/ControlGroups/Attachments.component';
import {GeneralDetailsComponent} from '../components/ControlGroups/GeneralDetails.component';
import {ContactDetailsComponent} from '../components/ControlGroups/ContactDetails.component';
import {CustomerRequirementsComponent} from '../components/ControlGroups/CustomerRequirements.component';
import {RemovalDetailsComponent} from '../components/ControlGroups/RemovalDetails.component';
import {CoolerDetailsComponent} from '../components/ControlGroups/CoolerDetails.component';
import {VendorDetailsComponent} from '../components/ControlGroups/VendorDetails.component';
import {FountainDetailsComponent} from '../components/ControlGroups/FountainDetails.component';
import {NotesComponent} from '../components/ControlGroups/Notes.component';

import {RequestHeaderComponent} from '../components/Controls/RequestHeader.component';

//base
import { BaseControlGroupComponent } from '../baseclasses/BaseControlGroup.component';

export abstract class BaseRequestComponent implements OnInit{
    @ViewChild(AttachmentsComponent) attachmentsComponent: AttachmentsComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChildren(BaseControlGroupComponent) controlGroups: QueryList<BaseControlGroupComponent>;
    openRequestTab: EventEmitter<Request>;
    request: ent.Request;
    public requestID: number;
    public salesOffice: ent.SalesOffice;
    userInfo: ent.UserInfo;
    appConfig: ent.AppConfig;
    protected authenticationService: serv.AuthenticationService;
    protected requestService: serv.RequestService; 
    protected domainDataService: serv.DomainDataService; 
    protected configService: serv.ConfigService; 
    protected router: Router;
    hideSalesAndDeliveryOnMaintainCustomer: boolean;
    ngOnInit() {};

    ngAfterViewInit(): void{
        this.getRequest(true);
    }

    constructor(){
        this.authenticationService = AppModule.injector.get(serv.AuthenticationService);
        this.requestService = AppModule.injector.get(serv.RequestService);
        this.domainDataService = AppModule.injector.get(serv.DomainDataService);
        this.router = AppModule.injector.get(Router);
        this.configService = AppModule.injector.get(serv.ConfigService);
        this.userInfo = this.authenticationService.getUserInfo();
        this.hideSalesAndDeliveryOnMaintainCustomer = this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.HideSalesAndDeliveryOnMaintainCustomer)[0].SettingValue == "true" ? true : false;

        this.appConfig = this.configService.appConfig;
    }

    public salesAndDeliveryOnMaintainCustomerHidden(): boolean {
        return this.hideSalesAndDeliveryOnMaintainCustomer;
        
    }

    getRequest(loadControlGroups: boolean, unblock: boolean=true){
        this.requestHeaderComponent.blockComponent.blocked = true;
        if (this.requestID && this.requestID > 0){
            
            var filter: filters.RequestFilter = {RequestID: this.requestID};
            this.requestService.getRequestWithDetails(filter).subscribe(x=> 
            { 
                this.request = x;
                this.requestHeaderComponent.request = x;
                this.setRequestInfo(this.request.ID, this.request.RequestTypeID);
                
                if (this.controlGroups){
                    var controlGroups = this.controlGroups.toArray();
            
                    for (var controlGroup of controlGroups){
                        controlGroup.setRequestInfo(x);
                    }
                }
                this.setDates();
                if (loadControlGroups){
                    this.loadControlGroups();
                }
                if (unblock) {
                    this.requestHeaderComponent.blockComponent.blocked = false;
                }
                
            }, err => {
                this.requestHeaderComponent.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                if (unblock) {
                    this.requestHeaderComponent.blockComponent.blocked = false;
                }
            });
        }
        else{
            this.loadControlGroups();
            this.requestHeaderComponent.blockComponent.blocked = false;
        }
    }
    setRequestInfo(requestID: number, requestTypeID: number){
        this.requestID = requestID;
        this.requestHeaderComponent.requestID = requestID;
        this.requestHeaderComponent.requestTypeID = requestTypeID;
        this.attachmentsComponent.requestID = requestID;
    }

    saveRequest(request: ent.Request){
        this.requestHeaderComponent.blockComponent.blocked = true;
        request.AppVersion = this.appConfig.Version;
        request.BrowserName = util.RequestUtil.getBrowserName();
        
        this.requestService.saveRequest(request).subscribe(x=>{
            this.setRequestInfo(x.RequestID, x.RequestTypeID);
            this.getRequest(false, false);
            this.requestHeaderComponent.handleResponse(x);
            this.requestHeaderComponent.blockComponent.blocked = false;
            this.requestHeaderComponent.saveInProgress = false;
        }, err => {
            this.requestHeaderComponent.blockComponent.blocked = false;
            this.requestHeaderComponent.saveInProgress = false;
        });
    }
    
    loadControlGroups(){
        if (this.controlGroups){
            var controlGroups = this.controlGroups.toArray();
            
            for (var controlGroup of controlGroups){
                controlGroup.loadDropDowns();
            }
        }

    }

    setDates(){
        if (this.controlGroups){
            var controlGroups = this.controlGroups.toArray();
            
            for (var controlGroup of controlGroups){
                controlGroup.setDates();
            }
        }

    }

    onExpandAllClick(event: any){
        this.expandCollapseAll(false);
    }

    onCollapseAllClick(event: any){
        this.expandCollapseAll(true);
    }

    expandCollapseAll(collapsed: boolean){
        
        if (this.controlGroups){
            var controlGroups = this.controlGroups.toArray();
            
            for (var controlGroup of controlGroups){
                controlGroup.collapsed = collapsed;
            }
        }
        
    }
}

export default BaseRequestComponent;